import MicrosoftCosmosDbReaderNode from './types/microsoft-cosmos-db-reader';
import MicrosoftCosmosDbV2ReaderNode from './types/microsoft-cosmos-db-v2-reader';

export const microsoftCosmosDbNodes = {
  microsoftCosmosDbReader: MicrosoftCosmosDbReaderNode,
  microsoftCosmosDbV2Reader: MicrosoftCosmosDbV2ReaderNode,
};
